module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f64a.3096aae4.svg";